import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../../services/login.service';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private loginService: LoginService, private cookieService: CookieService) {
  }

  ngOnInit() {
    this.loginService.handleLogout();
    this.cookieService.deleteAll('/', '.bmwgroup.com');
    this.cookieService.deleteAll('weni', '/');
    this.cookieService.deleteAll('SMSESSION', '.bmwgroup.com');
    this.deleteAllCookies();
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

}
